import { render } from "./AttributeNumber.vue?vue&type=template&id=3ee7d204&scoped=true"
import script from "./AttributeNumber.vue?vue&type=script&lang=js"
export * from "./AttributeNumber.vue?vue&type=script&lang=js"

import "./AttributeNumber.vue?vue&type=style&index=0&id=3ee7d204&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee7d204"]])

export default __exports__